import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '@/views/HomeView.vue';

function meta(title: string, description: string) {
  return {
    title,
    description
  };
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/AboutView.vue'),
    meta: meta("About Us", "About this website and its maker.")
  },
  {
    path: '/notes',
    name: 'notes',
    component: () => import('@/views/NotesView.vue'),
    meta: {
      title: "Theology Study Notes",
      description: "The notes written while studying theology."
    }
  },
  {
    path: '/markdown-view',
    name: 'markdown-view',
    component: () => import('@/views/NoteView.vue'),
    meta: {
      title: "Markdown View",
      description: "Markdown file rendered view."
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/SettingsView.vue'),
    meta: {
      title: "Settings",
      description: "Website settings."
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
